import './AddSpouse.css';

const AddSpouse = () => {
  return (
    <>
      <h1 className="coach-title">Coming soon</h1>
    </>
  );
};

export default AddSpouse;
